import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TrafficDeviationSearchService } from '@components/traffic-deviations/components/searches/services/traffic-deviation-search.service';
import { LineSearchResult } from '../../interfaces';
import { firstValueFrom, map } from 'rxjs';
import { LineSearchStop } from '../../interfaces/line-search-result';
import { TranslateModule } from '@ngx-translate/core';
import { SelectedTripsPipe } from './pipes/selected-stop-place.pipe';
import { SvgIconComponent } from '@modules/shared/components/svg-icon/svg-icon.component';
import { SpinnerComponent } from '@modules/shared/components';

interface RecordLineSearchStop {
  [routeId: string]: LineSearchStop[]
}

@Component({
    selector: 'app-selected-line',
    imports: [
    AsyncPipe,
    TranslateModule,
    SelectedTripsPipe,
    SvgIconComponent,
    SpinnerComponent
],
    templateUrl: './selected-line.component.html',
    styleUrls: ['./selected-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedLineComponent {
  private readonly _searchService = inject(TrafficDeviationSearchService);

  protected selectedLineInBlade$ = this._searchService.selectedLineInBlade$.asObservable();
  protected choosenLines$ = this._searchService.choosenLines$;
  protected trafficDeviationStopPlaces$ = this.choosenLines$.pipe(
    map((lines) => {
      let stopPlaces: RecordLineSearchStop[] = [];
      for (const line of lines) {
        if (!line.stopPlaces) continue;
        const index = line.routeId+line.firstStopDestinationSign;
        stopPlaces[index] = [];
        for (const stopArea of line.stopPlaces) {
          stopPlaces[index] = stopPlaces[index].concat(stopArea.stopPlaces.filter((s) => {
            return s.selected;
          }));
        }
      }
      return stopPlaces;
    })
  );

  protected async onClickSelectedLine(line: LineSearchResult): Promise<void> {
    const existingTrafficDeviationLoaded = await firstValueFrom(
      this._searchService.existingTrafficDeviationLoaded$
    );
    if (existingTrafficDeviationLoaded) return;
    line.selected = !line.selected;
    line.lineStopSearchLoader = true;
    await this._searchService.openStopsInBlade(line, false);
    line.lineStopSearchLoader = false;
  }

  protected onClickRemoveLine(line: LineSearchResult): void {
    this._searchService.removeLineFromChoosenLines(line);
  }

  protected trackByKey(key: string, index:number, item:unknown): string {
    return item[key];
  }
}